import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { Snackbar } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Logo from './image/logo_app.png'
import PiGrecoLogo from './image/pigreco_logo.png'

import Background from './image/image_login.jpg'

import AppMap from '../App'
import packageJson from '../../package.json';
import preval from 'preval.macro';
import moment from 'moment';

import NoteAppDialog from './noteAppDialog'
// API REQUEST
import axios from 'axios';
import {
  authLogin
} from '../backEnd/requestAPI';

const buildTimestamp = preval`module.exports = new Date().getTime();`;



function getDateString() {
  const lastUpdateMoment = moment.unix(buildTimestamp / 1000);
  const formattedDate = lastUpdateMoment.format('DD-MM-YYYY');

  return formattedDate;
};


function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center" style={{ color: '#ffffff', fontSize: '14px' }}>

      <p>  <b>Powered by</b>
        <br></br>
        <img src={PiGrecoLogo} height="34px" alt='PiGreco logo'></img>
        <br></br>
        <b>Versione {packageJson.version} del {getDateString()}
        </b> </p>

    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: `url(${Background})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));



function SignInSide(props) {
  const classes = useStyles();

  const { openNodeApp, guestLogin } = props


  return (
    <Grid container component="main" className={classes.root} >
      <Grid item xs={false} sm={4} md={8} className={classes.image} style={{ backgroundColor: "#005500" }} />

      <Grid item xs={12} sm={8} md={4} component={Paper} elevation={0} square style={{ backgroundColor: "#005500" }}>
        <div className={classes.paper} style={{ backgroundColor: "#005500" }}>


          <div style={{ marginBottom: '21px', textAlign: 'center', color: '#ffffff' }}>

            <p>
              <b>“Domotic nZeb Building System”</b>
              <br></br>
              Progetto n. 08CT4399090089
              <br></br>
              Azione 1.1.5 del Po fesr 2014-2024
              <br></br>
              CUP G68I18000670007
            </p>


            <img src={Logo} height="55px" style={{ padding: '13px', marginTop: '55px' }} alt='Logo app' />
            <Typography component="h1" variant="h4" style={{ fontSize: '21px' }}>
              <b>Portale Web</b>
              <br></br>
              Accesso ai dati Gis e Bim
            </Typography>
          </div>

          <Button
            fullWidth
            variant="contained"
            style={{
              background: '#99b815',
              color: '#FFFFFF',
              fontSize: '21px',
              borderRadius: '21px', 
              marginTop:'21px'
            }}
            onClick={() => guestLogin()}
          >
            <b>ACCEDI</b>
          </Button>


          <p style={{ textAlign: 'center', lineHeight: '1.5', color: '#ffffff', fontSize: '14px', marginTop:'55px'}}>
            Il progetto ha sviluppato un modello abitativo altamente efficiente integrando all’interno del prototipo nZEB e-DOMUS 4.0, un impianto di produzione e accumulo di energia da fonti rinnovabili, un sistema di domotica avanzato che sia in grado di offrire un completo controllo degli impianti e dei dispositivi elettronici ed una rete di sensori di monitoraggio energetico ambientale che supervisioni in tempo reale tutti i parametri diretti e indiretti correlati al fabbisogno energetico dell’immobile.
            <br></br>            <br></br>
            Il tutto secondo politiche che mettono al primo posto l’ottimizzazione e l’utilizzo intelligente delle risorse energetiche disponibili.
            <br></br>            <br></br>
            Un concept di casa del futuro modulare, temporanea, eco-sostenibile e intelligente.
          </p>
          <Copyright />


        </div>
      </Grid>
    </Grid>
  );
}


class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenWebGis: false,
      isOpenMessage: false,
      isOpenNoteApp: false,
      textMessage: '',
      isErrorAuthorized: false,
      isLoadingLogin: false,
    };
  };

  componentDidMount() {
    this.checkSessionActive()
  }

  onOpenWebGis = () => {
    this.setState({
      isOpenWebGis: true
    })
  }

  //Apre eventuali messaggi di errore
  openMessage = text => {
    this.setState(prevState => ({
      isOpenMessage: !prevState.isOpenMessage,
      textMessage: text,
    }))
  }


  openNoteApp = () => {
    this.setState(prevState => ({
      isOpenNoteApp: !prevState.isOpenNoteApp,
    }))
  }



  // ACCEDI COME OSPITE
  guestLogin = () => {

    this.setState({
      isLoadingLogin: true,
      isErrorAuthorized: false
    })

    let user = {
      username: "ospite",
      password: "ospite"
    }

    axios.post(authLogin,
      user).then(response => {
        let userAuth = response.data
        let userRole = userAuth.ruoli

        this.setState({
          isErrorAuthorized: false,
          isLoadingLogin: false
        }, () => {
          localStorage.setItem("USER_TOKEN", userAuth.access_token);
          localStorage.setItem("USER_ID", userAuth.utente.idUtente);
          localStorage.setItem("USER_NAME", userAuth.utente.nome + " " + userAuth.utente.cognome)
          localStorage.setItem("ROLES_USER", JSON.stringify(userRole));
          localStorage.setItem("USER_TOKEN_EXPIRATION_DATE", userAuth.expiration_date)
          localStorage.setItem("USER_TYPE", "GUEST")
          this.onOpenWebGis()
        })


      }).catch(error => {
        this.setState({
          isLoadingLogin: false,
          isErrorAuthorized: true
        })

        let statusCode = error.response.data.statusCode
        if (statusCode == 401) this.openMessage("Utente non autorizzato")
        else alert(error);

      });
  }

  checkSessionActive = () => {

    if (localStorage.getItem("USER_TOKEN")) {
      var dateToken = new Date(localStorage.getItem("USER_TOKEN_EXPIRATION_DATE"));
      this.setState({
        isOpenWebGis: new Date() < dateToken
      })
    }
  }

  render() {
    const { isOpenWebGis, isOpenMessage, textMessage, isErrorAuthorized, isLoadingLogin, isOpenNoteApp } = this.state
    return (
      <div>
        {isOpenWebGis ?
          <AppMap />
          :
          <SignInSide
            openWebGis={this.onOpenWebGis}
            openNodeApp={this.openNoteApp}
            guestLogin={this.guestLogin}
            isErrorAuthorized={isErrorAuthorized}
            isLoadingLogin={isLoadingLogin} />
        }


        {isOpenNoteApp &&
          <NoteAppDialog
            isOpen={isOpenNoteApp}
            closeDialog={this.openNoteApp}
          />}

        <Snackbar
          open={isOpenMessage}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          autoHideDuration={5000}
          onClose={() => this.openMessage("")}
          message={<span>{textMessage}</span>}
        />
      </div>
    );
  }
}

export default LoginPage;